export const SUBMODULE_NAME = 'headerAutomation';
